import { render, staticRenderFns } from "./VerPorEmpleado.vue?vue&type=template&id=60d1364c&"
import script from "./VerPorEmpleado.vue?vue&type=script&lang=js&"
export * from "./VerPorEmpleado.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports